module.exports = __webpack_public_path__ + "img/theme3.b33e9f3c.png";